
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import {
  getConfigFilesRequestBody,
  uploadConfigFilesFromStorage,
  UploadConfigFilesLibraryResponse,
} from './types';
import { RetrieveConfigFilesLibraryResponse } from '../entities/config-files-library-v1/models';
import { RemoveConfigFilesRequest } from '../entities/config-files-v1/remove-config-files-request';
import { axiosInstance } from "../axios-instance";

class ConfigurationFilesLibrary {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  uploadConfigFiles(input: any): Promise<AxiosResponse<UploadConfigFilesLibraryResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<UploadConfigFilesLibraryResponse>(`${this.baseUrl}/configFiles`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'multipart/form-data',
      },
    });
  }

  uploadConfigFilesFromStorage(
    input: URLSearchParams,
  ): Promise<AxiosResponse<uploadConfigFilesFromStorage>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<uploadConfigFilesFromStorage>(`${this.baseUrl}/configFiles/upload`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    });
  }

  downloadConfigFile(sha: string): Promise<AxiosResponse<string>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<string>(`${this.baseUrl}/configFiles/${sha}`, {
      params: {
        isDownloadable: true,
      },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      responseType: 'blob',
    });
  }

  getConfigFiles(
    input: getConfigFilesRequestBody,
  ): Promise<AxiosResponse<RetrieveConfigFilesLibraryResponse>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<RetrieveConfigFilesLibraryResponse>(`${this.baseUrl}/configFiles`, {
      params: input,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  getConfigFileMetaData(id: string): Promise<any> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get(`${this.baseUrl}/configFiles/${id}`, {
      headers: {
        'Content-Type': 'application/octet-stream',
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  deleteConfigFile(id: string): Promise<any> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.delete(`${this.baseUrl}/configFiles/${id}`, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  removeConfigFiles(parameters: RemoveConfigFilesRequest): Promise<any> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post(`${this.baseUrl}/removeConfigFiles`, parameters, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  updatePartNumber(id: string, payload: Object): Promise<any> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.patch(`${this.baseUrl}/configFiles/${id}`, payload, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
        'Content-Type': 'application/merge-patch+json',
      },
    });
  }
}

export default ConfigurationFilesLibrary;
